import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Menu from '@mui/material/Menu';
import React from 'react';
import Button from '/@/components/button';
import { useAnchorEl } from '/@/hooks/anchor-el/useAnchorEl';

/**
 * @typedef {import('@mui/material').MenuProps} MenuProps
 * @typedef {import('@mui/material').ButtonProps} ButtonProps
 * @param {{children:React.ReactNode[],label:React.ReactNode, ButtonProps:ButtonProps,MenuProps:MenuProps}} props
 * */
export default function Dropdown(props) {
    const { children, label, ButtonProps = {}, MenuProps = {} } = props;
    const [{ open, anchorEl }, { handleClick, handleClose }] = useAnchorEl();
    return (
        <React.Fragment>
            <Button
                endIcon={<KeyboardArrowDownIcon />}
                disableElevation
                variant='outlined'
                color='white'
                {...ButtonProps}
                onClick={(e) => {
                    e.stopPropagation();
                    handleClick(e);
                }}
            >
                {label}
            </Button>
            <Menu
                {...MenuProps}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{ ...MenuProps.sx, '& .MuiPaper-root': { width: (anchorEl && anchorEl.clientWidth) || '' } }}
            >
                <span
                    onClick={(e) => {
                        e.stopPropagation();
                        handleClose(e);
                    }}
                >
                    {children}
                </span>
            </Menu>
        </React.Fragment>
    );
}
